import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../../../utils/rel';
import { getBrandandSerialList, getSerialRecommen } from '../../../../../../services/api';
import EnqueryAlert from '../../../../components/enqueryAlert';
import PropTypes from 'prop-types';

class RightSeriesSearch extends React.PureComponent {
    static propTypes = {
        curCity: PropTypes.object,
    };
    state = {
        brandData: [],
        brandSelectName: '请选择品牌',
        brand: -1,
        serialSelectName: '请选择车系',
        serial: -1,
        seriesData: [],
        searchHref: 'javascript:void(0);',
        isBrandSelectShow: false,
        isSerialSelectShow: false,
        isEnqueryAlertShow: false,
        carSeriesData: {},
    };

    async componentDidMount() {
        try {
            const brandData = await getBrandandSerialList();

            this.setState({
                brandData,
            });
        } catch (e) {
            console.error(e);
        }
    }

    brandHandleSelect = e => {
        this.setState({
            brand: e.currentTarget.attributes['value'].value,
            brandSelectName: e.currentTarget.attributes['name'].value,
            seriesData: [],
            serial: -1,
            serialSelectName: '请选择车系',
            isBrandSelectShow: false,
            isSerialSelectShow: false,
        });
        const brandData = this.state.brandData;

        for (let el in brandData) {
            if (brandData[el].i.toString() === e.currentTarget.attributes['value'].value.toString()) {
                this.setState({
                    seriesData: brandData[el].c,
                });
            }
        }
    };
    serialHandleSelect = e => {
        this.setState({
            serial: e.currentTarget.attributes['value'].value,
            serialSelectName: e.currentTarget.attributes['name'].value,
            isSerialSelectShow: false,
        });
    };

    brandHandMouseLeave = () => {
        this.setState({
            isBrandSelectShow: false,
        });
    };
    brandSelectShow = () => {
        this.setState({
            isBrandSelectShow: true,
        });
    };
    serialHandMouseLeave = () => {
        this.setState({
            isSerialSelectShow: false,
        });
    };
    serialSelectShow = () => {
        this.setState({
            isSerialSelectShow: true,
        });
    };
    handleClick = () => {
        const carSeriesData = {
            brand: this.state.brand,
            serial: this.state.serial,
        };

        this.setState({
            carSeriesData,
            isEnqueryAlertShow: true,
        });
    };
    getChildData = res => {
        this.setState({
            isEnqueryAlertShow: res,
        });
    };
    render() {
        const {
            seriesData,
            searchHref,
            brandData,
            brand,
            brandSelectName,
            serialSelectName,
            serial,
            isBrandSelectShow,
            isSerialSelectShow,
            isEnqueryAlertShow,
            carSeriesData,
        } = this.state;

        return (
            <div className={styles.c_m_i}>
                <div className={styles.brand} onMouseLeave={this.brandHandMouseLeave}>
                    <div
                        className={isBrandSelectShow ? styles.brand_checked_click : styles.brand_checked}
                        value={brand}
                        onClick={this.brandSelectShow}>
                        {brandSelectName}
                        <i />
                    </div>
                    {isBrandSelectShow ? (
                        <ul>
                            <li>
                                <a
                                    href="javascript:void(0);"
                                    value="-1"
                                    name="请选择品牌"
                                    onClick={this.brandHandleSelect}>
                                    请选择品牌
                                </a>
                            </li>
                            {brandData.map((item, index) => (
                                <li key={index}>
                                    <a
                                        href="javascript:void(0);"
                                        value={item.i}
                                        name={item.n}
                                        onClick={this.brandHandleSelect}>
                                        {item.n}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        ''
                    )}
                </div>

                <div className={styles.serial} onMouseLeave={this.serialHandMouseLeave}>
                    <div
                        className={isSerialSelectShow ? styles.serial_checked_click : styles.serial_checked}
                        value={serial}
                        onClick={this.serialSelectShow}>
                        {serialSelectName}
                        <i />
                    </div>
                    {isSerialSelectShow ? (
                        <ul>
                            <li>
                                <a
                                    href="javascript:void(0);"
                                    value="-1"
                                    name="请选择车系"
                                    onClick={this.serialHandleSelect}>
                                    请选择车系
                                </a>
                            </li>
                            {seriesData.map((item, index) => (
                                <li key={index} label={item.n}>
                                    <h5>{item.n}</h5>
                                    {seriesData[index].s.map((serialItem, serialIndex) => (
                                        <a
                                            href="javascript:void(0);"
                                            key={serialIndex}
                                            value={serialItem.i}
                                            name={serialItem.n}
                                            onClick={this.serialHandleSelect}>
                                            {serialItem.n}
                                        </a>
                                    ))}
                                </li>
                            ))}
                        </ul>
                    ) : (
                        ''
                    )}
                </div>
                <a
                    href={searchHref}
                    target="_blank"
                    rel={rel}
                    className={styles.btn}
                    onClick={this.handleClick.bind(this)}>
                    询最低价
                </a>
                {isEnqueryAlertShow ? (
                    <EnqueryAlert news={this} carSeriesData={carSeriesData} curCity={this.props.curCity} />
                ) : (
                    ''
                )}
            </div>
        );
    }
}

export default errorBoundary(RightSeriesSearch);
